/**
 * index.ts - Organizr - Universal list and category management
 * 
 * CHANGE HISTORY:
 * - 251130_1612 danielbeer: Export new types and utilities for list management
 * - 251121_1248 danielbeer: Comment out UI component (has broken imports) - only export core functionality
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import { OrganizrManager } from './OrganizrManager';
export { OrganizrManager };
export { OrganizrProvider, useOrganizr } from './OrganizrContext';

// Export types
export type {
  ListData,
  ListItem,
  ListRegistry,
  ListRegistryEntry,
  LoadListRegistryOptions,
  LoadListOptions,
  SaveListOptions,
  ListOperationResult,
  OutlinerConversionOptions
} from './types';

// Export utilities
export {
  convertToOutlinerNodes,
  flattenNodes,
  convertFromOutlinerNodes,
  validateNodesForConversion
} from './utils/outliner-conversion';

// Singleton instance
let organizrInstance: OrganizrManager | null = null;

/**
 * Get or create the global Organizr instance
 */
export function getOrganizr(options?: { actr?: any }): OrganizrManager {
  if (!organizrInstance && options?.actr) {
    organizrInstance = new OrganizrManager({ actr: options.actr });
  }
  
  if (!organizrInstance) {
    throw new Error('Organizr not initialized. Call getOrganizr({ actr }) first.');
  }
  
  return organizrInstance;
}

// UI components
export { default as Organizr } from './Organizr';
export { default as OrganizrUI } from './Organizr';
export { ListManagerView } from './components/ListManagerView';
export { ListPicker } from './components/ListPicker';
export { ListInfo } from './components/ListInfo';

// Hooks
export { useListManager } from './hooks/useListManager';
export type { UseListManagerOptions, UseListManagerReturn } from './hooks/useListManager';

// Component prop types
export type { ListManagerViewProps } from './components/ListManagerView';
export type { ListPickerProps } from './components/ListPicker';
export type { ListInfoProps } from './components/ListInfo';
